const DEFAULT_SPORTS = [
  {
    id: 'corrida',
    name: 'Corrida 5 km',
    active: true,
    selection_type: 'individual',
    shirt: {
      enabled: true,
      required: true,
      sizes: ['P', 'M', 'G', 'GG', 'XG'],
    },
  },
  {
    id: 'tenis',
    name: 'Tênis de Campo',
    active: true,
    selection_type: 'individual',
    categories: {
      enabled: true,
      required: true,
      multiple: false,
      options: [
        'Tênis I – Intermediário / Avançado',
        'Tênis II – Iniciante / Intermediário',
        'Feminino',
      ],
    },
  },
  {
    id: 'domino',
    name: 'Dominó',
    active: true,
    selection_type: 'double',
    partner_name: {
      enabled: true,
      required: false,
      label: 'Nome do parceiro (opcional)',
    },
  },
  {
    id: 'beach_tennis',
    name: 'Beach Tennis',
    active: true,
    selection_type: 'double',
    categories: {
      enabled: true,
      required: true,
      multiple: true,
      options: ['Masculino', 'Feminino', 'Misto'],
    },
    partner_name: {
      enabled: true,
      required: false,
      label: 'Nome do parceiro(a) (opcional)',
    },
  },
  {
    id: 'futebol',
    name: 'Futebol',
    active: true,
    selection_type: 'individual',
  },
  {
    id: 'volei',
    name: 'Vôlei de Praia 4x4',
    active: true,
    selection_type: 'team',
  },
  {
    id: 'nao_participar_esportes',
    name: 'Não irei participar de modalidades esportivas',
    active: true,
    special_type: 'opt_out',
  },
];

const DEFAULT_SARAU = [
  { id: 'artes_visuais', name: 'Artes Visuais', active: true },
  { id: 'literatura', name: 'Literatura', active: true },
  { id: 'artes_cenicas', name: 'Artes Cênicas', active: true },
  { id: 'musica', name: 'Música', active: true },
  { id: 'danca', name: 'Dança', active: true },
  {
    id: 'outros',
    name: 'Outros',
    active: true,
    extra_text: {
      enabled: true,
      required: false,
      label: 'Descreva a atividade',
    },
  },
  {
    id: 'nao_participar_sarau',
    name: 'Não irei participar do Sarau',
    active: true,
    special_type: 'opt_out',
  },
];

const DEFAULT_TERMS = [
  {
    field: 'aptidao_fisica',
    label:
      'Declaro estar apto(a) fisicamente para participar das atividades esportivas.',
    required: true,
  },
  {
    field: 'regras_organizacao',
    label: 'Estou ciente e concordo com as regras da organização.',
    required: true,
  },
  {
    field: 'uso_imagem',
    label:
      'Autorizo o uso de imagem em materiais institucionais do Sindilegis.',
    required: false,
  },
  {
    field: 'lgpd',
    label:
      'Autorizo o Sindilegis a coletar, armazenar e tratar meus dados pessoais exclusivamente para fins do evento, conforme a Lei 13.709/2018.',
    required: true,
  },
];

const DEFAULT_AGE_VALIDATION_MODE = 'birth_year';

const normalizeBoolean = (value, fallback = false) => {
  if (typeof value === 'boolean') return value;
  if (value === 'true') return true;
  if (value === 'false') return false;
  return fallback;
};

const normalizeInteger = (value, fallback) => {
  const parsed = parseInt(value, 10);
  return Number.isNaN(parsed) ? fallback : parsed;
};

const normalizeNumber = (value, fallback) => {
  const parsed = parseFloat(value);
  return Number.isNaN(parsed) ? fallback : parsed;
};

const normalizeList = (value, fallback = []) => {
  if (Array.isArray(value)) {
    return value.map((item) => `${item}`.trim()).filter(Boolean);
  }

  if (typeof value === 'string') {
    return value
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean);
  }

  return fallback;
};

const parseRawConfig = (activity = {}) => {
  const rawConfig = activity.station_specific_data || activity.body;
  if (!rawConfig) return {};
  try {
    return typeof rawConfig === 'string' ? JSON.parse(rawConfig) : rawConfig;
  } catch (e) {
    return {};
  }
};

const parseBirthdayToDate = (birthday) => {
  if (!birthday) return null;

  if (birthday instanceof Date && !Number.isNaN(birthday.getTime())) {
    return birthday;
  }

  if (typeof birthday !== 'string') return null;

  const trimmedBirthday = birthday.trim();
  if (!trimmedBirthday) return null;

  let date = null;

  if (/^\d{4}-\d{2}-\d{2}$/.test(trimmedBirthday)) {
    const [year, month, day] = trimmedBirthday
      .split('-')
      .map((value) => parseInt(value, 10));
    date = new Date(year, month - 1, day);
    if (
      date.getFullYear() !== year ||
      date.getMonth() !== month - 1 ||
      date.getDate() !== day
    ) {
      return null;
    }
    return date;
  }

  if (/^\d{2}\/\d{2}\/\d{4}$/.test(trimmedBirthday)) {
    const [day, month, year] = trimmedBirthday
      .split('/')
      .map((value) => parseInt(value, 10));
    date = new Date(year, month - 1, day);
    if (
      date.getFullYear() !== year ||
      date.getMonth() !== month - 1 ||
      date.getDate() !== day
    ) {
      return null;
    }
    return date;
  }

  return null;
};

export const normalizeBirthday = (birthday) => {
  const date = parseBirthdayToDate(birthday);
  if (!date) return null;
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const formatPhone = (value = '') => {
  const digits = `${value}`.replace(/\D/g, '').slice(0, 11);

  if (!digits) return '';
  if (digits.length <= 2) return `(${digits}`;
  if (digits.length <= 3) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  if (digits.length <= 7) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 3)} ${digits.slice(3)}`;
  }

  return `(${digits.slice(0, 2)}) ${digits.slice(2, 3)} ${digits.slice(
    3,
    7
  )}-${digits.slice(7)}`;
};

export const isValidBirthday = (birthday, { now = new Date() } = {}) => {
  const date = parseBirthdayToDate(birthday);
  if (!date) return false;
  return date.getTime() <= now.getTime();
};

export const normalizeAgeValidationMode = () => DEFAULT_AGE_VALIDATION_MODE;

export const resolveAgeReferenceDate = (...candidates) => {
  for (const candidate of candidates) {
    if (!candidate) continue;
    const date = candidate instanceof Date ? candidate : new Date(candidate);
    if (!Number.isNaN(date.getTime())) {
      return date;
    }
  }

  return new Date();
};

export const getAgeFromBirthday = (
  birthday,
  {
    referenceDate = new Date(),
    ageValidationMode = DEFAULT_AGE_VALIDATION_MODE,
  } = {}
) => {
  const birthDate = parseBirthdayToDate(birthday);
  if (!birthDate) return null;

  const normalizedReferenceDate = resolveAgeReferenceDate(referenceDate);

  if (ageValidationMode === 'birth_year') {
    return normalizedReferenceDate.getFullYear() - birthDate.getFullYear();
  }

  let age = normalizedReferenceDate.getFullYear() - birthDate.getFullYear();
  const monthDiff = normalizedReferenceDate.getMonth() - birthDate.getMonth();

  if (
    monthDiff < 0 ||
    (monthDiff === 0 && normalizedReferenceDate.getDate() < birthDate.getDate())
  ) {
    age -= 1;
  }

  return age;
};

const normalizeSport = (sport, index) => {
  const shirtSizes = normalizeList(sport.shirt?.sizes);
  const categoryOptions = normalizeList(sport.categories?.options);
  return {
    id: sport.id || `sport_${index + 1}`,
    name: sport.name || '',
    active: normalizeBoolean(sport.active, true),
    selection_type: sport.selection_type || 'individual',
    special_type: sport.special_type || '',
    shirt: {
      // Se o gestor listou tamanhos, considera habilitado mesmo que o switch
      // do lab esteja OFF — evita perder config por engano de toggle.
      enabled:
        normalizeBoolean(sport.shirt?.enabled, false) || shirtSizes.length > 0,
      required: normalizeBoolean(sport.shirt?.required, false),
      sizes: shirtSizes,
    },
    categories: {
      enabled:
        normalizeBoolean(sport.categories?.enabled, false) ||
        categoryOptions.length > 0,
      required: normalizeBoolean(sport.categories?.required, false),
      multiple: normalizeBoolean(sport.categories?.multiple, false),
      maxSelection: Math.max(
        normalizeInteger(sport.categories?.max_selection, 2),
        1
      ),
      options: categoryOptions,
    },
    partner_name: {
      enabled: normalizeBoolean(sport.partner_name?.enabled, false),
      required: normalizeBoolean(sport.partner_name?.required, false),
      label: sport.partner_name?.label || 'Nome do parceiro(a)',
    },
  };
};

const normalizeSarau = (item, index) => ({
  id: item.id || `sarau_${index + 1}`,
  name: item.name || '',
  active: normalizeBoolean(item.active, true),
  special_type: item.special_type || '',
  extra_text: {
    enabled: normalizeBoolean(item.extra_text?.enabled, false),
    required: normalizeBoolean(item.extra_text?.required, false),
    label: item.extra_text?.label || 'Descreva a atividade',
  },
});

export const getSportFieldKeys = (sport) => ({
  selected: sport.id,
  shirt: `${sport.id}_shirt_size`,
  categories: `${sport.id}_categories`,
  partner: `${sport.id}_partner_name`,
});

export const getSarauFieldKeys = (item) => ({
  selected: item.id,
  details: `${item.id}_details`,
});

const buildPricingTiers = (rawAdditionalRoom = {}, fallback = {}) => {
  const rawTiers = rawAdditionalRoom.pricing_tiers;
  if (Array.isArray(rawTiers) && rawTiers.length > 0) {
    return rawTiers.map((tier) => ({
      room_price: normalizeNumber(tier?.room_price, 0),
      companion_price: normalizeNumber(tier?.companion_price, 0),
    }));
  }
  if (
    Array.isArray(fallback.additionalRoomPricingTiers) &&
    fallback.additionalRoomPricingTiers.length > 0
  ) {
    return fallback.additionalRoomPricingTiers.map((tier) => ({
      room_price: normalizeNumber(tier?.room_price, 0),
      companion_price: normalizeNumber(tier?.companion_price, 0),
    }));
  }
  return [
    {
      room_price: normalizeNumber(
        rawAdditionalRoom.room_price ?? fallback.extraRoomPrice,
        1000
      ),
      companion_price: normalizeNumber(
        rawAdditionalRoom.companion_price,
        0
      ),
    },
  ];
};

const buildHotelRoomRules = (rawRoomRules = {}, fallback = {}) => ({
  roomPeopleLimit: normalizeInteger(
    rawRoomRules.room_people_limit ?? fallback.roomPeopleLimit,
    3
  ),
  minorAgeLimit: normalizeInteger(
    rawRoomRules.minor_age_limit ?? fallback.minorAgeLimit,
    17
  ),
  firstRoomPayingLimit: normalizeInteger(
    rawRoomRules.first_room?.paying_companion_limit ??
      fallback.firstRoomPayingLimit,
    2
  ),
  additionalRoomPayingLimit: normalizeInteger(
    rawRoomRules.additional_room?.paying_companion_limit ??
      fallback.additionalRoomPayingLimit,
    2
  ),
  companionPrice: normalizeNumber(
    rawRoomRules.first_room?.companion_price ?? fallback.companionPrice,
    700
  ),
  extraRoomPrice: normalizeNumber(
    rawRoomRules.additional_room?.room_price ?? fallback.extraRoomPrice,
    1000
  ),
  additionalRoomChargeEnabled: normalizeBoolean(
    rawRoomRules.additional_room?.charge_enabled,
    fallback.additionalRoomChargeEnabled !== false
  ),
  additionalRoomPricingTiers: buildPricingTiers(
    rawRoomRules.additional_room || {},
    fallback
  ),
  minorsFree: normalizeBoolean(
    rawRoomRules.minors_free,
    fallback.minorsFree !== false
  ),
  minorsCountTowardsRoomLimit: normalizeBoolean(
    rawRoomRules.minors_count_towards_room_limit,
    !!fallback.minorsCountTowardsRoomLimit
  ),
  minorsCountTowardsPayment: normalizeBoolean(
    rawRoomRules.minors_count_towards_payment,
    !!fallback.minorsCountTowardsPayment
  ),
  firstRoomFreeLimit: normalizeInteger(
    rawRoomRules.first_room?.free_companion_limit ??
      fallback.firstRoomFreeLimit,
    0
  ),
  additionalRoomFreeLimit: normalizeInteger(
    rawRoomRules.additional_room?.free_companion_limit ??
      fallback.additionalRoomFreeLimit,
    0
  ),
  totalRoomsAvailable: parseInt(rawRoomRules.total_rooms_available, 10) || 0,
  maxRoomsPerRegistration:
    parseInt(rawRoomRules.max_rooms_per_registration, 10) || 0,
  ageValidationMode: normalizeAgeValidationMode(
    rawRoomRules.age_validation_mode
  ),
  ageReferenceDate: fallback.ageReferenceDate,
});

export const parseCopaSarauActivityConfig = (activity = {}) => {
  const parsed = parseRawConfig(activity);
  const config = parsed.copa_sarau_config || parsed || {};
  const roomRules = config.room_rules || {};

  const rawSports = (
    (config.modalities?.sports?.length ? config.modalities.sports : null) ||
    (parsed.modalities?.sports?.length ? parsed.modalities.sports : null) ||
    DEFAULT_SPORTS
  )
    .map(normalizeSport)
    .filter((sport) => sport.active);

  const seenSportIds = new Set();
  const dedupedSports = rawSports.filter((sport) => {
    if (seenSportIds.has(sport.id)) return false;
    seenSportIds.add(sport.id);
    return true;
  });
  const sports = dedupedSports.some((sport) => sport.special_type === 'opt_out')
    ? dedupedSports
    : [
        ...dedupedSports,
        normalizeSport({
          id: 'nao_participar_esportes',
          name: 'Não irei participar de modalidades esportivas',
          active: true,
          special_type: 'opt_out',
        }),
      ];

  const rawSarau = (
    (config.modalities?.sarau?.length ? config.modalities.sarau : null) ||
    (parsed.modalities?.sarau?.length ? parsed.modalities.sarau : null) ||
    DEFAULT_SARAU
  )
    .map(normalizeSarau)
    .filter((item) => item.active);

  // Deduplicar itens por id para evitar opções repetidas (ex.: opt_out salvo em duplicata)
  const seenIds = new Set();
  const dedupedSarau = rawSarau.filter((item) => {
    if (seenIds.has(item.id)) return false;
    seenIds.add(item.id);
    return true;
  });
  const sarau = dedupedSarau.some((item) => item.special_type === 'opt_out')
    ? dedupedSarau
    : [
        ...dedupedSarau,
        normalizeSarau({
          id: 'nao_participar_sarau',
          name: 'Não irei participar do Sarau',
          active: true,
          special_type: 'opt_out',
        }),
      ];

  const ageReferenceDate = resolveAgeReferenceDate(
    config.event_start,
    activity.event_start,
    activity.start,
    activity.participationStart,
    activity.participationEnd,
    activity.end
  );
  const ageValidationMode = normalizeAgeValidationMode(
    roomRules.age_validation_mode
  );
  const legacyHotelFallback = {
    roomPeopleLimit: normalizeInteger(
      roomRules.room_people_limit ??
        parsed.body_max_per_room ??
        activity.room_limit,
      3
    ),
    minorAgeLimit: normalizeInteger(
      roomRules.minor_age_limit ?? parsed.body_age_limit,
      17
    ),
    firstRoomPayingLimit: normalizeInteger(
      roomRules.first_room?.paying_companion_limit,
      2
    ),
    additionalRoomPayingLimit: normalizeInteger(
      roomRules.additional_room?.paying_companion_limit,
      2
    ),
    companionPrice: normalizeNumber(
      roomRules.first_room?.companion_price ??
        parsed.body_valor_acompanhante ??
        activity.companion_price,
      700
    ),
    extraRoomPrice: normalizeNumber(
      roomRules.additional_room?.room_price ??
        parsed.body_valor_quarto_extra ??
        activity.extra_room_price,
      1000
    ),
    additionalRoomChargeEnabled: normalizeBoolean(
      roomRules.additional_room?.charge_enabled,
      true
    ),
    additionalRoomPricingTiers: buildPricingTiers(
      roomRules.additional_room || {},
      {
        extraRoomPrice: normalizeNumber(
          roomRules.additional_room?.room_price ??
            parsed.body_valor_quarto_extra ??
            activity.extra_room_price,
          1000
        ),
      }
    ),
    minorsFree: normalizeBoolean(roomRules.minors_free, true),
    minorsCountTowardsRoomLimit: normalizeBoolean(
      roomRules.minors_count_towards_room_limit,
      false
    ),
    minorsCountTowardsPayment: normalizeBoolean(
      roomRules.minors_count_towards_payment,
      false
    ),
    firstRoomFreeLimit: normalizeInteger(
      roomRules.first_room?.free_companion_limit,
      0
    ),
    additionalRoomFreeLimit: normalizeInteger(
      roomRules.additional_room?.free_companion_limit,
      0
    ),
    ageReferenceDate,
    ageValidationMode,
  };

  const rawHotels = Array.isArray(config.hotels) ? config.hotels : [];
  const hotels = (
    rawHotels.length > 0
      ? rawHotels
      : [
          {
            id: 'hotel_principal',
            name: 'Hotel principal',
            description: '',
            active: true,
            room_rules: roomRules,
          },
        ]
  ).map((hotel, index) => ({
    id: hotel.id || `hotel_${index + 1}`,
    name: hotel.name || `Hotel ${index + 1}`,
    description: hotel.description || '',
    active: normalizeBoolean(hotel.active, true),
    roomRules: {
      ...buildHotelRoomRules(hotel.room_rules || {}, legacyHotelFallback),
      ageReferenceDate,
      ageValidationMode,
    },
  }));

  return {
    sports,
    sarau,
    hotels,
    sportsLimit: normalizeInteger(
      config.sports_limit ?? parsed.body_max_modalidades,
      3
    ),
    sarauLimit: normalizeInteger(
      config.sarau_limit ?? parsed.body_max_sarau,
      3
    ),
    roomRules: {
      roomPeopleLimit: normalizeInteger(
        roomRules.room_people_limit ??
          parsed.body_max_per_room ??
          activity.room_limit,
        3
      ),
      minorAgeLimit: normalizeInteger(
        roomRules.minor_age_limit ?? parsed.body_age_limit,
        17
      ),
      firstRoomPayingLimit: normalizeInteger(
        roomRules.first_room?.paying_companion_limit,
        2
      ),
      additionalRoomPayingLimit: normalizeInteger(
        roomRules.additional_room?.paying_companion_limit,
        2
      ),
      companionPrice: normalizeNumber(
        roomRules.first_room?.companion_price ??
          parsed.body_valor_acompanhante ??
          activity.companion_price,
        700
      ),
      extraRoomPrice: normalizeNumber(
        roomRules.additional_room?.room_price ??
          parsed.body_valor_quarto_extra ??
          activity.extra_room_price,
        1000
      ),
      additionalRoomChargeEnabled: normalizeBoolean(
        roomRules.additional_room?.charge_enabled,
        true
      ),
      additionalRoomPricingTiers: buildPricingTiers(
        roomRules.additional_room || {},
        {
          extraRoomPrice: normalizeNumber(
            roomRules.additional_room?.room_price ??
              parsed.body_valor_quarto_extra ??
              activity.extra_room_price,
            1000
          ),
        }
      ),
      minorsFree: normalizeBoolean(roomRules.minors_free, true),
      minorsCountTowardsRoomLimit: normalizeBoolean(
        roomRules.minors_count_towards_room_limit,
        false
      ),
      minorsCountTowardsPayment: normalizeBoolean(
        roomRules.minors_count_towards_payment,
        false
      ),
      firstRoomFreeLimit: normalizeInteger(
        roomRules.first_room?.free_companion_limit,
        0
      ),
      additionalRoomFreeLimit: normalizeInteger(
        roomRules.additional_room?.free_companion_limit,
        0
      ),
      ageValidationMode: normalizeAgeValidationMode(
        roomRules.age_validation_mode
      ),
      ageReferenceDate: resolveAgeReferenceDate(
        config.event_start,
        activity.event_start,
        activity.start,
        activity.participationStart,
        activity.participationEnd,
        activity.end
      ),
    },
    terms: config.terms || {},
    cancellationPhone:
      parsed.body_telefone_cancelamento ||
      config.terms?.cancellation_phone ||
      '',
    defaultTerms: DEFAULT_TERMS,
    customQuestions: parseCustomQuestions(activity),
  };
};

const FIXED_QUESTION_TEXTS = new Set([
  'nome completo',
  'cpf',
  'e-mail',
  'email',
  'telefone celular',
  'celular',
  'data de nascimento',
  'cidade',
  'estado/uf',
  'estado',
  'uf',
  'situação funcional',
  'situacao funcional',
  'matrícula',
  'matricula',
  'órgão de lotação',
  'orgao de lotacao',
]);

const SUPPORTED_CUSTOM_QUESTION_TYPES = new Set([1, 2, 3, 4, 5]);

const normalizeQuestionOption = (option) => {
  if (!option || typeof option !== 'object') return null;
  const rawLabel = option.label;
  const labelText =
    rawLabel && typeof rawLabel === 'object'
      ? rawLabel.text || ''
      : rawLabel || '';
  const value = option.value || labelText;
  return {
    id: option.id ?? value ?? labelText,
    label: labelText,
    value,
  };
};

export const parseCustomQuestions = (activity = {}) => {
  const questions = activity?.researches?.[0]?.questions;
  if (!Array.isArray(questions)) return [];

  return questions
    .map((q) => {
      const text = (q.question || '').toString();
      const type = parseInt(q.type_id ?? q.type, 10);
      if (!text || !SUPPORTED_CUSTOM_QUESTION_TYPES.has(type)) return null;

      const normalizedText = text.trim().toLowerCase();
      if (FIXED_QUESTION_TEXTS.has(normalizedText)) return null;

      const options = Array.isArray(q.options)
        ? q.options.map(normalizeQuestionOption).filter(Boolean)
        : [];

      return {
        id: q.id,
        text,
        type,
        options,
      };
    })
    .filter(Boolean);
};

export const findHotelInActivity = (activityConfig, hotelId) => {
  if (!activityConfig || !Array.isArray(activityConfig.hotels)) return null;
  if (!hotelId) return null;
  return (
    activityConfig.hotels.find((hotel) => String(hotel.id) === String(hotelId)) ||
    null
  );
};

export const resolveActiveRoomRules = (activityConfig, hotelId) => {
  const hotel = findHotelInActivity(activityConfig, hotelId);
  if (hotel) return hotel.roomRules;
  return activityConfig?.roomRules || {};
};

export const isPartnerPerCategory = (sport) =>
  !!(
    sport &&
    sport.partner_name?.enabled &&
    sport.categories?.enabled &&
    sport.categories?.multiple
  );

export const buildDynamicSelections = (config) => {
  const modalities = {};
  const sarauActivities = {};

  config.sports.forEach((sport) => {
    const keys = getSportFieldKeys(sport);
    modalities[keys.selected] = false;
    if (sport.shirt.enabled) modalities[keys.shirt] = '';
    if (sport.categories.enabled)
      modalities[keys.categories] = sport.categories.multiple ? [] : '';
    if (sport.partner_name.enabled)
      modalities[keys.partner] = isPartnerPerCategory(sport) ? {} : '';
  });

  config.sarau.forEach((item) => {
    const keys = getSarauFieldKeys(item);
    sarauActivities[keys.selected] = false;
    if (item.extra_text.enabled) sarauActivities[keys.details] = '';
  });

  return { modalities, sarauActivities };
};

export const countSelectedSports = (modalities, sports) =>
  sports.filter(
    (sport) => sport.special_type !== 'opt_out' && modalities[sport.id]
  ).length;

export const countSelectedSarau = (sarauActivities, sarau) =>
  sarau.filter(
    (item) => item.special_type !== 'opt_out' && sarauActivities[item.id]
  ).length;

export const getSelectedSportsSummary = (modalities, sports) => {
  return sports
    .filter((sport) => modalities[sport.id])
    .map((sport) => {
      const keys = getSportFieldKeys(sport);
      const details = [];

      if (sport.shirt.enabled && modalities[keys.shirt]) {
        details.push(`Tamanho: ${modalities[keys.shirt]}`);
      }

      if (sport.categories.enabled) {
        const categoriesValue = modalities[keys.categories];
        if (Array.isArray(categoriesValue) && categoriesValue.length > 0) {
          details.push(`Categorias: ${categoriesValue.join(', ')}`);
        } else if (categoriesValue) {
          details.push(`Categoria: ${categoriesValue}`);
        }
      }

      if (sport.partner_name.enabled) {
        const partnerValue = modalities[keys.partner];
        if (isPartnerPerCategory(sport)) {
          if (partnerValue && typeof partnerValue === 'object') {
            const selectedCategories = Array.isArray(
              modalities[keys.categories]
            )
              ? modalities[keys.categories]
              : [];
            selectedCategories.forEach((category) => {
              const partnerName = partnerValue[category];
              if (partnerName) {
                details.push(
                  `${sport.partner_name.label} (${category}): ${partnerName}`
                );
              }
            });
          }
        } else if (partnerValue) {
          details.push(`${sport.partner_name.label}: ${partnerValue}`);
        }
      }

      return details.length > 0
        ? `${sport.name} - ${details.join(' | ')}`
        : sport.name;
    });
};

export const getSelectedSarauSummary = (sarauActivities, sarau) => {
  return sarau
    .filter((item) => sarauActivities[item.id])
    .map((item) => {
      const keys = getSarauFieldKeys(item);
      const details = item.extra_text.enabled && sarauActivities[keys.details];
      return details
        ? `${item.name}: ${sarauActivities[keys.details]}`
        : item.name;
    });
};

export const isMinorByBirthYear = (
  birthday,
  minorAgeLimit = 17,
  {
    referenceDate = new Date(),
    ageValidationMode = DEFAULT_AGE_VALIDATION_MODE,
  } = {}
) => {
  const age = getAgeFromBirthday(birthday, {
    referenceDate,
    ageValidationMode,
  });
  if (age === null) return false;
  return age <= minorAgeLimit;
};

export const getCompanionPaymentStatus = (companion = {}, roomRules = {}) => {
  const normalizedBirthday =
    normalizeBirthday(companion.birthday) || companion.birthday;
  const parsedMinorAgeLimit = parseInt(roomRules.minorAgeLimit, 10);
  const minorAgeLimit = Number.isFinite(parsedMinorAgeLimit)
    ? parsedMinorAgeLimit
    : 17;
  const age = getAgeFromBirthday(normalizedBirthday, {
    referenceDate: roomRules.ageReferenceDate,
    ageValidationMode: roomRules.ageValidationMode,
  });
  const legalMinor = age !== null && age < 18;
  const configuredMinor =
    age !== null &&
    isMinorByBirthYear(normalizedBirthday, minorAgeLimit, {
      referenceDate: roomRules.ageReferenceDate,
      ageValidationMode: roomRules.ageValidationMode,
    });
  const isPaying = !configuredMinor || !!roomRules.minorsCountTowardsPayment;

  if (legalMinor && isPaying && !configuredMinor) {
    return {
      label: `(Menor - pagante porque é maior de ${minorAgeLimit} anos)`,
      legalMinor,
      configuredMinor,
      isPaying,
    };
  }

  if (legalMinor || configuredMinor) {
    return {
      label: isPaying ? '(Menor - pagante)' : '(Menor - não pagante)',
      legalMinor,
      configuredMinor,
      isPaying,
    };
  }

  return {
    label: '',
    legalMinor,
    configuredMinor,
    isPaying,
  };
};

export const normalizeCompanions = (companions = [], roomRules = {}) => {
  return companions.map((companion) => {
    const normalizedBirthday =
      normalizeBirthday(companion.birthday) || companion.birthday;
    const hasValidBirthday = isValidBirthday(normalizedBirthday);
    const isMinor = hasValidBirthday
      ? isMinorByBirthYear(normalizedBirthday, roomRules.minorAgeLimit, {
          referenceDate: roomRules.ageReferenceDate,
          ageValidationMode: roomRules.ageValidationMode,
        })
      : typeof companion.is_minor === 'boolean'
        ? companion.is_minor
        : false;

    return {
      ...companion,
      birthday: normalizedBirthday,
      is_minor: isMinor,
    };
  });
};

export const assignCompanionsToRooms = (companions = [], roomRules = {}) => {
  const normalizedCompanions = normalizeCompanions(companions, roomRules);
  const firstRoomPayingLimit = Math.max(
    parseInt(roomRules.firstRoomPayingLimit, 10) || 0,
    0
  );
  const additionalRoomPayingLimit = Math.max(
    parseInt(roomRules.additionalRoomPayingLimit, 10) ||
      firstRoomPayingLimit ||
      1,
    1
  );
  const roomPeopleLimit = Math.max(
    parseInt(roomRules.roomPeopleLimit, 10) || 0,
    0
  );
  const firstRoomOccupancyLimit = Math.max(
    roomPeopleLimit > 0 ? roomPeopleLimit - 1 : 0,
    0
  );
  const additionalRoomOccupancyLimit = Math.max(
    roomPeopleLimit || additionalRoomPayingLimit,
    1
  );
  const minorsCountTowardsRoomLimit = !!roomRules.minorsCountTowardsRoomLimit;
  const minorsCountTowardsPayment = !!roomRules.minorsCountTowardsPayment;
  const firstRoomFreeLimit = Math.max(
    parseInt(roomRules.firstRoomFreeLimit, 10) || 0,
    0
  );
  const additionalRoomFreeLimit = Math.max(
    parseInt(roomRules.additionalRoomFreeLimit, 10) || 0,
    0
  );

  const getLimits = (roomIndex) =>
    roomIndex === 0
      ? {
          paying: firstRoomPayingLimit,
          occupancy: firstRoomOccupancyLimit,
          free: firstRoomFreeLimit,
        }
      : {
          paying: additionalRoomPayingLimit,
          occupancy: additionalRoomOccupancyLimit,
          free: additionalRoomFreeLimit,
        };

  const enriched = normalizedCompanions.map((companion, index) => ({
    companion,
    index,
    countsForPayment: !companion.is_minor || minorsCountTowardsPayment,
    countsForOccupancy: !companion.is_minor || minorsCountTowardsRoomLimit,
  }));

  const rooms = [];
  const assignments = new Array(enriched.length).fill(1);

  // aloca quem paga preservando a ordem de inscrição. Se não cabe
  // em nenhuma sala aberta, abre uma nova.
  enriched
    .filter((entry) => entry.countsForPayment)
    .forEach((entry) => {
      let targetRoom = -1;
      for (let i = 0; i < rooms.length; i += 1) {
        const limits = getLimits(i);
        const payingOk = limits.paying === 0 || rooms[i].paying < limits.paying;
        const occupancyOk =
          !entry.countsForOccupancy ||
          limits.occupancy === 0 ||
          rooms[i].occupancy < limits.occupancy;
        if (payingOk && occupancyOk) {
          targetRoom = i;
          break;
        }
      }
      if (targetRoom === -1) {
        rooms.push({ paying: 0, occupancy: 0, free: 0 });
        targetRoom = rooms.length - 1;
      }
      rooms[targetRoom].paying += 1;
      if (entry.countsForOccupancy) rooms[targetRoom].occupancy += 1;
      assignments[entry.index] = targetRoom + 1;
    });

  // acompanhantes que não pagam (menores isentos). Tenta empacotar
  // nas salas já abertas antes de abrir uma nova, respeitando free_limit e
  // occupancy_limit quando a config manda contá-los.
  enriched
    .filter((entry) => !entry.countsForPayment)
    .forEach((entry) => {
      let targetRoom = -1;
      for (let i = 0; i < rooms.length; i += 1) {
        const limits = getLimits(i);
        const occupancyOk =
          !entry.countsForOccupancy ||
          limits.occupancy === 0 ||
          rooms[i].occupancy < limits.occupancy;
        const freeOk = limits.free === 0 || rooms[i].free < limits.free;
        if (occupancyOk && freeOk) {
          targetRoom = i;
          break;
        }
      }
      if (targetRoom === -1) {
        rooms.push({ paying: 0, occupancy: 0, free: 0 });
        targetRoom = rooms.length - 1;
      }
      if (entry.countsForOccupancy) rooms[targetRoom].occupancy += 1;
      rooms[targetRoom].free += 1;
      assignments[entry.index] = targetRoom + 1;
    });

  return enriched.map((entry) => ({
    ...entry.companion,
    room_number: assignments[entry.index],
    is_paying: entry.countsForPayment,
  }));
};

export const calculateAccommodationTotals = (
  companions = [],
  roomRules = {}
) => {
  const normalizedCompanions = assignCompanionsToRooms(companions, roomRules);
  const minorsCountTowardsRoomLimit = !!roomRules.minorsCountTowardsRoomLimit;
  const companionPrice = normalizeNumber(roomRules.companionPrice, 700);
  const extraRoomPrice = normalizeNumber(roomRules.extraRoomPrice, 1000);
  const additionalRoomChargeEnabled =
    roomRules.additionalRoomChargeEnabled !== false;
  const pricingTiers =
    Array.isArray(roomRules.additionalRoomPricingTiers) &&
    roomRules.additionalRoomPricingTiers.length > 0
      ? roomRules.additionalRoomPricingTiers
      : [{ room_price: extraRoomPrice, companion_price: 0 }];

  const freeCompanions = normalizedCompanions.filter(
    (companion) => !companion.is_paying
  );
  const payingInRoom1 = normalizedCompanions.filter(
    (companion) => companion.is_paying && (companion.room_number || 1) === 1
  ).length;
  const extraRooms = Math.max(
    Math.max(
      ...normalizedCompanions.map((companion) => companion.room_number || 1),
      1
    ) - 1,
    0
  );
  const roomOccupantsCount = normalizedCompanions.filter(
    (companion) => !companion.is_minor || minorsCountTowardsRoomLimit
  ).length;
  const companionTotal = payingInRoom1 * companionPrice;

  let roomTotal = 0;
  if (additionalRoomChargeEnabled && extraRooms > 0) {
    const getTier = (slot) =>
      pricingTiers[Math.min(slot - 1, pricingTiers.length - 1)];
    for (let slot = 1; slot <= extraRooms; slot++) {
      const tier = getTier(slot);
      const roomNumber = slot + 1;
      const payingInThisRoom = normalizedCompanions.filter(
        (c) => c.is_paying && (c.room_number || 1) === roomNumber
      ).length;
      roomTotal +=
        normalizeNumber(tier.room_price, 0) +
        payingInThisRoom * normalizeNumber(tier.companion_price, 0);
    }
  }

  return {
    normalizedCompanions,
    payingCompanions: payingInRoom1,
    freeCompanions: freeCompanions.length,
    roomOccupantsCount,
    extraRooms,
    companionTotal,
    roomTotal,
    total: companionTotal + roomTotal,
    companionPrice,
    extraRoomPrice,
    additionalRoomPricingTiers: pricingTiers,
    additionalRoomChargeEnabled,
  };
};

export const formatExtraRoomsBillingLabel = (totals = {}) => {
  const extraRooms = Math.max(parseInt(totals.extraRooms, 10) || 0, 0);
  const payingPeopleInExtraRooms = Array.isArray(totals.normalizedCompanions)
    ? totals.normalizedCompanions.filter(
        (companion) => companion.is_paying && (companion.room_number || 1) > 1
      ).length
    : 0;

  const roomLabel =
    extraRooms === 1
      ? '1 Quarto adicional'
      : `${extraRooms} Quartos adicionais`;
  const peopleLabel =
    payingPeopleInExtraRooms === 1
      ? '1 pessoa pagante'
      : `${payingPeopleInExtraRooms} pessoas pagantes`;

  return `${roomLabel} (${peopleLabel})`;
};
